import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CountsRoutingModule } from './counts-routing.module';
import { CountListPageComponent } from './pages/count-list-page/count-list-page.component';
import { LeadCountListComponent } from './components/lists/lead-count-list/lead-count-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LeadCountsComponent } from './components/counts/lead-counts/lead-counts.component';
import { AppointmentCountsComponent } from './components/counts/appointment-counts/appointment-counts.component';
import { AppointmentListComponent } from './components/lists/appointment-list/appointment-list.component';
import { CclCountsComponent } from './components/counts/ccl-counts/ccl-counts.component';
import { CustomerVisitCountsComponent } from './components/counts/customer-visit-counts/customer-visit-counts.component';
import { PermitCountsComponent } from './components/counts/permit-counts/permit-counts.component';
import { ProductionCountsComponent } from './components/counts/production-counts/production-counts.component';
import { ProductionManagementCountsComponent } from './components/counts/production-management-counts/production-management-counts.component';
import { ProductionSchedulingCountsComponent } from './components/counts/production-scheduling-counts/production-scheduling-counts.component';
import { ProposalCountsComponent } from './components/counts/proposal-counts/proposal-counts.component';
import { SalesManagementCountsComponent } from './components/counts/sales-management-counts/sales-management-counts.component';
import { ServiceCountsComponent } from './components/counts/service-counts/service-counts.component';
import { ServiceManagementCountsComponent } from './components/counts/service-management-counts/service-management-counts.component';
import { CclCountsListComponent } from './components/lists/ccl-counts-list/ccl-counts-list.component';
import { PermitCountsListComponent } from './components/lists/permit-counts-list/permit-counts-list.component';
import { ProductionCountsListComponent } from './components/lists/production-counts-list/production-counts-list.component';
import { ProductionManagementCountsListComponent } from './components/lists/production-management-counts-list/production-management-counts-list.component';
import { ProductionSchedulingCountsListComponent } from './components/lists/production-scheduling-counts-list/production-scheduling-counts-list.component';
import { ProposalCountsListComponent } from './components/lists/proposal-counts-list/proposal-counts-list.component';
import { SalesManagementCountsListComponent } from './components/lists/sales-management-counts-list/sales-management-counts-list.component';
import { ServiceCountsListComponent } from './components/lists/service-counts-list/service-counts-list.component';
import { ServiceManagementCountsListComponent } from './components/lists/service-management-counts-list/service-management-counts-list.component';
import { CustomerVisitCountsListComponent } from './components/lists/customer-visit-counts-list/customer-visit-counts-list.component';
import { UtilityCountsComponent } from './components/counts/utility-counts/utility-counts.component';
import { UtilityCountsListComponent } from './components/lists/utility-counts-list/utility-counts-list.component';
import { MailingRequestsCountListComponent } from './components/lists/mailing-requests-count-list/mailing-requests-count-list.component';
import { AccountingCountsComponent } from './components/counts/accounting-counts/accounting-counts.component';
import { AccountingCountsListComponent } from './components/lists/accounting-counts-list/accounting-counts-list.component';
import { SharedComponentModule } from 'src/app/shared/shared-component.module';
import { PendingProductionManagerApprovalCountsComponent } from './components/counts/pending-production-manager-approval-counts/pending-production-manager-approval-counts.component';
import { PendingProductionManagerApprovalListComponent } from './components/lists/pending-production-manager-approval-list/pending-production-manager-approval-list.component';

@NgModule({
  declarations: [
    PendingProductionManagerApprovalCountsComponent,
    PendingProductionManagerApprovalListComponent,
    CountListPageComponent,
    LeadCountListComponent,
    LeadCountsComponent,
    AppointmentCountsComponent,
    AppointmentListComponent,
    CclCountsComponent,
    CustomerVisitCountsComponent,
    PermitCountsComponent,
    ProductionCountsComponent,
    ProductionManagementCountsComponent,
    ProductionSchedulingCountsComponent,
    ProposalCountsComponent,
    SalesManagementCountsComponent,
    ServiceCountsComponent,
    ServiceManagementCountsComponent,
    CclCountsListComponent,
    PermitCountsListComponent,
    ProductionCountsListComponent,
    ProductionManagementCountsListComponent,
    ProductionSchedulingCountsListComponent,
    ProposalCountsListComponent,
    SalesManagementCountsListComponent,
    ServiceCountsListComponent,
    ServiceManagementCountsListComponent,
    CustomerVisitCountsListComponent,
    UtilityCountsComponent,
    UtilityCountsListComponent,
    MailingRequestsCountListComponent,
    AccountingCountsComponent,
    AccountingCountsListComponent,
  ],
  imports: [CommonModule, CountsRoutingModule, SharedModule, SharedComponentModule],
  exports: [
    PendingProductionManagerApprovalCountsComponent,
    LeadCountsComponent,
    AppointmentCountsComponent,
    CclCountsComponent,
    CustomerVisitCountsComponent,
    PermitCountsComponent,
    ProductionCountsComponent,
    ProductionManagementCountsComponent,
    ProductionSchedulingCountsComponent,
    ProposalCountsComponent,
    SalesManagementCountsComponent,
    ServiceCountsComponent,
    ServiceManagementCountsComponent,
    UtilityCountsComponent,
    AccountingCountsComponent,
  ],
})
export class CountsModule {}
